import cookies from 'js-cookie';
import { cookieNames } from '~client/constants';

export const getCookieDomain = () => {
  return window.location.hostname.split('.').slice(-2).join('.');
};

export const setLoginCookie = (rememberMe, token) => {
  if (rememberMe) {
    cookies.set(cookieNames.token, token, {
      path: '/',
      expires: 7,
      domain: getCookieDomain(),
      sameSite: 'Lax',
    });
  } else {
    cookies.set(cookieNames.token, token, {
      path: '/',
      domain: getCookieDomain(),
      sameSite: 'Lax',
    });
  }
  //额外设置cookie 给image 服务读取 。
  cookies.set(cookieNames.imgToken, token, {
    path: '/',
    domain: getCookieDomain(),
    sameSite: 'None',
    secure: true,
  });
};
